import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";
import { images } from "../data/content";
export function Hero() {
  return <header className="px-5 pb-14 pt-8 md:pb-20 md:pt-12" data-id="element-171" data-mp="9lv0spiridvb">
      <div className="mx-auto max-w-4xl text-center" data-id="element-172" data-mp="4lqiqv27hb2z">
        <div className="flex flex-wrap items-center justify-center gap-2.5" data-id="element-173" data-mp="4n1j0kwg00pc">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-plum-800 text-white" data-id="element-174" data-mp="129qvjoortvpg">
            <ShieldCheckIcon className="h-5 w-5" aria-hidden data-id="element-175" data-mp="xbfmhg6avp8a" />
          </span>
          <span className="font-display text-xl font-extrabold text-plum-900" data-id="element-176" data-mp="saruar6c52ch">Implant Decision System™</span>
        </div>

        <h1 className="mt-7 font-display text-[34px] font-extrabold leading-[1.1] text-ink md:text-6xl" data-id="element-177" data-mp="nb6n5th0hnoo">
          Analyze an implant case in{" "}
          <em className="italic text-plum-600" data-id="element-178" data-mp="3cz5weevm861x">under 15 minutes</em> before you reach the surgical chair
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-ink/75 md:text-xl" data-id="element-179" data-mp="3j8selyn99fos">
          The <strong className="text-ink" data-id="element-180" data-mp="3o7c4ga4yzbmf">7-Decision System</strong> to assess case suitability, identify risk
          factors, review the key findings on CBCT, and turn clinical information into a{" "}
          <strong className="text-ink" data-id="element-181" data-mp="3e8wkqs89v4my">structured pre-surgical plan</strong>.
        </p>

        <img src={images.mockup} alt="Implant Decision System: 6 volumes, 5 bonuses, decision trees, checklists and case-planning sheets" className="mx-auto mt-6 w-full max-w-2xl" data-id="element-182" data-mp="30iaziwvciilw" />

        <p className="mx-auto -mt-1 max-w-xl text-[15px] font-medium text-ink/70" data-id="element-183" data-mp="2qkmsb7gjzimu">
          Includes <strong className="text-plum-700" data-id="element-184" data-mp="2vievixmner6c">6 premium volumes</strong> +{" "}
          <strong className="text-plum-700" data-id="element-185" data-mp="2hj5drtisnp09">5 professional bonuses</strong> + decision trees, risk matrices,
          case-planning sheets, and clinical checklists.
        </p>

        <div className="mt-7" data-id="element-186" data-mp="2lmv00cbzxui4">
          <CtaButton id="hero-cta" label="Get my Implant Decision System™" sub="Instant access · One-time payment of $27 USD · Lifetime access · 7-Day Guarantee" data-id="element-187" data-mp="s1rsao8pe6ua" />
        </div>

        <div className="mt-8" data-id="element-188" data-mp="id9u8ert6duc">
          <Countdown data-id="element-189" data-mp="ichwaxaqo40w" />
          <p className="mt-4 text-sm text-ink/55" data-id="element-190" data-mp="i9vu7d6magq2">
            <strong className="text-ink/75" data-id="element-191" data-mp="degf6hwvies2">Launch pricing.</strong> The promotional price may change after the launch
            period.
          </p>
        </div>
      </div>
    </header>;
}